import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    devices: [],
    allDevices: [],
    devicesTotal: null,
    viewDevicesLoader: false,
    page: 1,
    perPage: 5,
    deviceTypes: [],
    searchQuery: null,
    filterValue: null,
    viewTransactionLog: [],
    viewTransactionLogTotal: null,
    perPageLog: 5,
    currentPageLog: 1,
    viewTransactionCommand: {},
    idRoute: null,
    allDeviceUsers: [],
    allDeviceUsersTotal: null,
    pageUserMgt: 1,
    perPageUserMgt: 5,
    device_id: "",
    command_type: "",
  },
  actions,
  mutations,
};
